import { Form, FormProps } from "antd"
import classNames from "classnames"

import { BaseError } from "@src/shared/form/base_error"
import css from "./index.module.css"

type FormContainer<T> = FormProps<T> & {
  baseError?: string
}
export const FormContainer = <T extends unknown>({
  baseError,
  children,
  className,
  layout = "vertical",
  size = "large",
  ...props
}: FormContainer<T>) => {
  return (
    <Form
      {...props}
      className={classNames(css.form, className)}
      id="GENERATED_ID_FORMCONTAINER_FORM_VOID_1"
      layout={layout}
      size={size}
    >
      <BaseError error={baseError} />
      <>{children}</>
    </Form>
  )
}
